import React from 'react';

const PieChartIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.7483 2.07517C14.733 1.76721 13.8109 2.48733 13.6453 3.41096L12.5751 9.3816C12.36 10.5813 13.4067 11.628 14.6064 11.4129L20.5771 10.3427C21.5007 10.1771 22.2208 9.25498 21.9128 8.23967C21.0189 5.29249 18.6955 2.96911 15.7483 2.07517Z"
      fill="#00A389"
    />
    <g opacity="0.4">
      <path
        d="M12.0264 3.94488C12.0468 3.83074 11.9662 3.72298 11.8507 3.71321C11.5902 3.69117 11.3267 3.67993 11.0605 3.67993C5.95191 3.67993 1.81055 7.8213 1.81055 12.9299C1.81055 18.0386 5.95191 22.1799 11.0605 22.1799C16.1692 22.1799 20.3105 18.0386 20.3105 12.9299C20.3105 12.663 20.2992 12.3986 20.2771 12.1374C20.2673 12.0219 20.1595 11.9413 20.0454 11.9618L14.8717 12.8892C12.6436 13.2886 10.6999 11.3448 11.0993 9.11674L12.0264 3.94488Z"
        fill="#00A389"
      />
      <path
        d="M13.5376 4.01534C16.6543 4.87949 19.1096 7.33424 19.9745 10.4506L14.6071 11.4127C13.4073 11.6278 12.3607 10.5811 12.5758 9.3814L13.5376 4.01534Z"
        fill="#00A389"
      />
    </g>
  </svg>
);

export default PieChartIcon;
